import {
  EnvironmentVariableKeys,
  getEnvironmentVariable
} from '../environments/environment-variables';

/**
 * Gets the default api server's base url
 */
export const getApiServerBaseUrl = () => {
  let url = new URL(window.location.href);
  if (process.env.NODE_ENV === 'development') {
    if (url.hostname.startsWith('localhost')) {
      url.port = '80';
    }
  }

  if (process.env.NODE_ENV === 'test') {
    url = new URL('http://mockapi-ceh.teams.microsoft.com');
  }

  const prefix = process.env.REACT_APP_API_SERVER_OVERRIDE_PREFIX;
  if (prefix) {
    url.hostname = prefix + url.hostname;
  }

  const serverOverrideEnvironmentVariable = getEnvironmentVariable(
    EnvironmentVariableKeys.apiServerOverride
  );
  const serverOverrideUrl = process.env.REACT_APP_API_SERVER_OVERRIDE
    ? process.env.REACT_APP_API_SERVER_OVERRIDE
    : serverOverrideEnvironmentVariable;
  if (serverOverrideUrl) {
    url = new URL(serverOverrideUrl);
  }

  if (process.env.REACT_APP_API_SERVER_OVERRIDE_PORT) {
    url.port = process.env.REACT_APP_API_SERVER_OVERRIDE_PORT;
  }

  if (!url.pathname.endsWith('/')) {
    url.pathname += '/';
  }
  url.hash = '';
  url.search = '';
  return url;
};

/**
 * Gets an api server url based on the base url
 * @param pathName The path name of the api
 * @param queryStringParams The query string parameters
 * @param encode This parameter is only respected when mocking is enabled
 */
export const getApiServerUrl = (
  pathName: string,
  queryStringParams: { [key: string]: string | undefined } = {},
  encode: boolean = true
) => {
  const url = getApiServerBaseUrl();
  url.pathname = pathName;

  if (process.env.REACT_APP_DEV_ENABLE_MOCKS !== 'true' && encode) {
    Object.keys(queryStringParams).forEach((key: string) => {
      const value = queryStringParams[key];
      if (value !== undefined) {
        url.searchParams.set(key, value);
      }
    });
  } else {
    // This option should get dead code removed on production builds where mocks are disabled
    let search = '';
    Object.keys(queryStringParams).forEach((key: string, index: number) => {
      const value = queryStringParams[key];
      if (value !== undefined) {
        if (index === 0) {
          search += key + '=' + value;
        } else {
          search += '&' + key + '=' + value;
        }
      }
    });
    url.search = search;
  }

  // Workaround for Edge url pollyfill issue
  const uri = url.toString().replace('#', '');
  if (uri.endsWith('?')) {
    uri.replace('?', '');
  }
  return uri;
};
